/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { DropdownModel } from '../../../../../core/models';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class NamespaceService {
    /**
     * Section is valid set next button as active.
     */
    public selectedEmitter: Subject<any> = new Subject<any>();

    /**
     * Section is valid set next button as active.
     */
    public changeEmitter: Subject<any> = new Subject<any>();

    /**
     * Set the ability to disable the dropdown externally.
     */
    public disableEmitter: Subject<any> = new Subject<any>();

    /**
     * Store namespaces in the service.
     * @private
     */
    private _namespaces: any[] = [];

    /**
     * Store the selected namespace in the service.
     * @private
     */
    private _selectedNamespace: DropdownModel;

    /**
     * Gets namespaces.
     */
    get namespaces() {
        return this._namespaces;
    }

    /**
     * Sets namespaces.
     * @param namespaces
     */
    set namespaces(namespaces: any[]) {
        if (namespaces?.length && namespaces[0].hasOwnProperty('id')) {
            this._namespaces = NamespaceService.formatNamespacesForDropdown(namespaces);
        } else {
            this._namespaces = namespaces;
        }

        if (!this.selectedNamespace && this.namespaces?.length) {
            this.selectedNamespace = this.namespaces[0];
        }

        this.changeEmitter.next(this.namespaces);
    }

    /**
     * Gets selected namespace.
     */
    get selectedNamespace() {
        return this._selectedNamespace;
    }

    /**
     * Set selected namespace.
     * @param namespace
     */
    set selectedNamespace(namespace: DropdownModel) {
        this._selectedNamespace = namespace;
        this.selectedEmitter.next(namespace);
    }

    /**
     * Option to reset the service (used in logout function).
     */
    public resetService(): void {
        this.namespaces = [];
        this.selectedNamespace = null;
    }

    /**
     * Format namespaces
     * @param namespaces
     * @private
     */
    private static formatNamespacesForDropdown(namespaces: any): DropdownModel[] {
        const formattedNamespaces = [{ key: 0, value: 'All' }];
        for (const namespace of namespaces) {
            formattedNamespaces.push(
                <DropdownModel>{ key: namespace.id, value: namespace.name }
            );
        }

        return formattedNamespaces;
    }
}
